<template>
  <input
    type="text"
    autocomplete="false"
    class="cm-field location-input"
    v-model="value"
    :id="inputId"
    :name="paramName"
    @input="$emit('input', $event.target.value)"
    @keydown.enter.prevent>
</template>

<script>
  import GoogleMapsLoader from '../lib/google-maps'
  import FormOptions from './mixins/form-options'

  export default {
    mixins: [FormOptions],

    props: {
      types: {
        type: String,
        default: '["geocode"]',
      },
    },

    mounted() {
      const types = JSON.parse(this.types)
      GoogleMapsLoader.load(google => {
        const autocomplete = new google.maps.places.Autocomplete(this.$el, { 
          types: types,
          fields: ["name", "geometry.location"]
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
          this.$emit('input', this.$el.value);
        });
      });
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/location-field.vue?79ede364